import { createStore } from '@stencil/store';

import { Vehicle } from '../interfaces/interface.vehicle';
import { baseVehicleState } from '../utils/utils.vehicle';

const initialState: CompareVehicleData = {
  // These are named in an overly verbose way since they are surfaced on the eligiblity hydrator
  compareVehicleVin: '',
  vinVehicleConfigs: [],
  ymmtVehicleConfig: { ...baseVehicleState },
  confirmedVehicleConfig: { ...baseVehicleState },
  isValid: false,
};

export interface CompareVehicle extends Vehicle {
  hasYmmtMatch: boolean;
}

export interface CompareVehicleData {
  compareVehicleVin: string;
  vinVehicleConfigs: CompareVehicle[];
  ymmtVehicleConfig: Vehicle;
  confirmedVehicleConfig: Vehicle;
  isValid: boolean;
}

const { on, onChange, state, reset } = createStore(initialState);

export { initialState, on, onChange, state, reset };
export default state;
